<template>
  <ValidationProvider v-slot="{ errors }" rules="required">
    <Select
      :value="selectedOption"
      @change="handleChange"
      label=""
      item-text="label"
      item-value="value"
      :items="questionOptions"
      :error-messages="showValidationErrors ? errors : []"
      autocomplete
    />
  </ValidationProvider>
</template>

<script>
import Select from "@/components/common/Select";
import { ValidationProvider } from "vee-validate";
import { map, first } from "lodash";
import {
  getAnswerIdByValue,
  getAnswerValueById
} from "@/views/profile/QuestionsAndAnswers/utils";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    Select,
    ValidationProvider
  },
  created() {
    const { answerData, options } = this.question;
    if (answerData) {
      this.selectedOption = getAnswerIdByValue({
        questionOptions: options,
        answer: first(answerData.answers)
      });
    }
  },
  data() {
    return {
      selectedOption: null
    };
  },
  computed: {
    questionOptions() {
      return map(this.question.options, option => ({
        label: option.option,
        value: option.id
      }));
    }
  },
  methods: {
    handleChange(value) {
      this.selectedOption = value;
      this.$emit("onChange", {
        question: {
          type: "booking-application-questions",
          id: this.question.id
        },
        answers: [
          getAnswerValueById({
            questionOptions: this.question.options,
            id: value
          })
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
